//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    gap: 8px;
    & div[data-role="content"] {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
        & > *:not(div):last-child {
            min-width: 100px;
        }
    }
`;
export const ContentText = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 8px 15px;
    min-width: 250px;
    border-radius: 5px;
    width: max-content;
    border: 1px solid var(--purple-1);
    transition: 0.3s background-color;
    cursor: pointer;
    &:hover {
        background-color: #4318CD25;      
    }
    &.error {
        border-color: var(--red-2);
    }
    & span {
        color: var(--dark-4);
        font-size: 14px;
        &.placeholder {
            color: var(--light-gray-5);                
        }
    }
`;